<template>

  <CommonPrivateView>
    <template v-slot:header>
      
      <div class="py-8">
        <div class="w-full flex flex-col items-center justify-center mx-auto" v-if="empresaProducto">
          <img v-if="empresaProducto.previewFotoFile" :src="empresaProducto.previewFotoFile" class="w-auto h-36 rounded-lg border border-white mx-auto" />
          <div v-else class="w-36 h-36 rounded-lg border border-white mx-auto" />

          <a @click="isFileUploadVisible = true" v-if="empresaProducto" class="cursor-pointer mt-3 py-2 px-4 block rounded-lg border border-white bg-transparent text-white hover:bg-black hover:text-white">
            <font-awesome-icon :icon="['fas', 'upload']" />
            SUBIR FOTO
          </a>
        </div>          
      </div>
        
    </template>
    <template v-slot:content>
      
      <div v-if="!empresaProducto" class="h-screen">Cargando...</div>

      <Form @submit="onSubmit" class="w-full" :validation-schema="schema" @invalid-submit="onInvalidSubmit" v-if="empresaProducto">
      
        <div class="w-full text-gray-600 px-0 mx-auto flex justify-center">
          <div class="w-full space-y-4 pb-5">

            <div class="mx-auto block w-full">
              <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-3" >
                <div class="flex items-center justify-between font-semibold text-lg ">
                  PRODUCTO
                </div>
                <div class="w-full">

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Descripción</label>
                  <Field name="descripcion" v-slot="{ field, errors }" v-model="empresaProducto.descripcion">
                    <InputText v-bind="field" type="text" placeholder="Descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="descripcion" /></span>
                  </Field>
                </div>
              </div>
              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Detalles</label>
                  <Field name="detalles" v-slot="{ field, errors }" v-model="empresaProducto.detalles">
                    <Textarea rows="4" v-bind="field" type="text" placeholder="Breve descripción del producto" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="detalles" /></span>
                  </Field>
                </div>
              </div>
              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">Orden</label>
                  <Field name="orden" v-slot="{ field, errors }" v-model="empresaProducto.orden">
                    <InputText v-bind="field" type="numeric" placeholder="Orden" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="orden" /></span>
                  </Field>
                </div>
              </div>
              </div> 
              </div>
              <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-3" >
                <div class="flex items-center justify-between font-semibold text-lg ">
                  CATEGORÍAS
                </div>
                <div class="w-full">
                    <div v-if="tags">
                      <div v-for="tag in tags" v-bind:key="tag.id" :tag="tag">
                        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                          <div class="w-full px-2">
                            <label class="block mb-1">{{tag.descripcion}}</label>
                            <Field :name="`tag-${tag.id}`" v-slot="{ errors }">
                              <MultiSelect :model-value="tag.opcionesTagSeleccionados" @update:model-value="val => tag.opcionesTagSeleccionados = val" :options="tag.opciones" optionLabel="descripcion" optionValue="id" filter :placeholder="tag.descripcion" class="input-base" :class="{'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }"/>
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          
              
              <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-1 mt-3" >
                <div class="w-full">
                  <div class="flex flex-col md:flex-row my-2 gap-2 mt-2">
                    <button type="submit" class="px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
                      :disabled="isSubmitting">
                      <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
                      <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ACEPTAR
                    </button>
                    <button type="button" @click="cancelarModificacion" class="px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded"
                      :disabled="isSubmitting">
                      <i class="pi pi-times mr-2"></i>CANCELAR
                    </button>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <!-- FORM CARD -->

        </div>      
      </Form>

    </template>
  </CommonPrivateView>

  <BlockUI :blocked="isSubmitting" fullScreen />

  <ModalFileUpload :visible="isFileUploadVisible" :askDescription="false" :forceSquare="false"
        :maxSizeMB="2" :fileTypes="['image/png', 'image/jpg', 'image/jpeg']"
        :onAccept="onFileUploadAcepted" @update:visible="isFileUploadVisible = $event" />

  <CropperView v-if="showCropper" :image="beforeCropBase64" @close="onCropFinished" />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import MultiSelect from 'primevue/multiselect';

import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';
import ModalFileUpload from "@/components/commons/ModalFileUpload.vue";

import suiteConfig from '@/services/suite.config';
import empresaService from 'qreventos-suite/empresas';
import seguridadServices from '@/services/seguridad.services';
import { EmpresaProducto, UsuarioEmpresa, Tag, ProductoTag, TagOpcion } from 'qreventos-suite/src/services/suite.interfaces';
import { TAG_TIPO_PRODUCTO } from 'qreventos-suite/constantes';

import CropperView from '@/components/commons/CropperView.vue'

export default defineComponent({
  components: {
    InputText, BlockUI, Textarea, MultiSelect,
    Form, ErrorMessage, Field,
    CommonPrivateView, ModalFileUpload,
    CropperView
  },
  created() {
    document.title = "Producto";
  },
  data() {
    return {
      isSubmitting: false,
      empresaProducto: undefined as unknown as EmpresaProducto,
      usuarioEmpresa: seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa,
      isFileUploadVisible: false,
      tags: [] as Tag[],

      beforeCropBase64: '',
      showCropper: false,

    };
  },
  computed: {
    schema() {
      const tagValidations = this.tags?.reduce((acc: Record<string, yup.AnySchema>, tag) => {
          const fieldName = `tag-${tag.id}`;
          acc[fieldName] = tag.obligatorio
            ? yup.array().min(1, `Seleccioná al menos una opción para "${tag.descripcion}"`).required()
            : yup.array().notRequired();
          return acc;
        }, {});

      return yup.object({
        descripcion: yup.string().required('Ingresá la descripción').min(3, 'Al menos 3 letras'),        
        detalles: yup.string().required('Ingresá el detalle').min(50, 'Al menos 50 letras'),
        ...tagValidations,
      });
    }
  },
  methods: {
    async onFileUploadAcepted(base64: string, fileName: string) {
      const base64Splited:string = base64.split(',')[1];

      this.empresaProducto.fotoFileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      this.empresaProducto.fotoBase64 = base64Splited;
      
      this.beforeCropBase64 = base64;
      //this.empresaProducto.previewFotoFile = base64;
      this.showCropper = true;

    },
    async onCropFinished(croppedBase64:string) {
      this.showCropper = false
      if (!croppedBase64) return

      const base64Splited = croppedBase64.split(',')[1]
      this.empresaProducto.fotoBase64 = base64Splited
      this.empresaProducto.previewFotoFile = croppedBase64

      await empresaService.saveOrUpdateProducto(this.usuarioEmpresa.evento.id, this.empresaProducto);

    },    
    cancelarModificacion() {
      this.$router.push({ path: '/productos' });
    },
    async fillProducto() {
      this.isSubmitting = true;

      try {
        this.usuarioEmpresa = await seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
        this.tags = await empresaService.findTagsBy(this.usuarioEmpresa.evento.id, TAG_TIPO_PRODUCTO);

        const idProducto:number = Number(this.$route.params.id);
        if(idProducto) {
          this.empresaProducto = await empresaService.findProductoByPk(this.usuarioEmpresa.evento.id, idProducto);
          if(this.tags.length > 0) {
              for(let i:number = 0; i < this.tags.length; i++) {
                const tag:Tag = this.tags[i];            
                tag.opcionesTagSeleccionados = this.empresaProducto.productoTags.filter(productoTag => productoTag.tag.id === tag.id).map(productoTag => productoTag.tagOpcion.id);
              }
            }
        } else {
          this.empresaProducto = {} as EmpresaProducto;
          
        }
        
        
      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Por favor revisá el formulario<br/>Se encontraron " + errores + " campos con error.", icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        this.empresaProducto.productoTags = [] as ProductoTag[];
        this.tags.forEach(tag => {          
            tag.opcionesTagSeleccionados.forEach(tagOpcionSeleccionada => {
              const empresaTag:ProductoTag = {} as ProductoTag;
              empresaTag.tag = tag;
              empresaTag.tagOpcion = { "id" : tagOpcionSeleccionada } as TagOpcion;
              this.empresaProducto.productoTags.push(empresaTag);
            })
          });
        this.empresaProducto.empresa = this.usuarioEmpresa.empresa;
        await empresaService.saveOrUpdateProducto(this.usuarioEmpresa.evento.id, this.empresaProducto);

        Swal.fire({
            title: "¡Atención!",
            html: "Su transacción se realizó con éxito.",
            icon: "success",
        }).then(() => {
          this.$router.push({ path: '/productos' });
        });

      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    try {
      empresaService.clientId = suiteConfig.clientId;
      empresaService.token = suiteConfig.token;

      this.fillProducto();
    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }
  }
});
</script>
